import { render, staticRenderFns } from "./ReservationsProfile.vue?vue&type=template&id=2963a1b2"
import script from "./ReservationsProfile.vue?vue&type=script&lang=js"
export * from "./ReservationsProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports